import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=46794ea9&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=46794ea9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46794ea9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46794ea9')) {
      api.createRecord('46794ea9', component.options)
    } else {
      api.reload('46794ea9', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=46794ea9&scoped=true&", function () {
      api.rerender('46794ea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pageLayout/sidebar.vue"
export default component.exports